/**
 * Drone buffering utilities — single source of truth.
 *
 * Mirrors backend Service.bufferedCount() in services.js.
 * Both EventDetail and DispatchPage import from here so the
 * formula never diverges.
 */

/**
 * Buffer a single drone count.
 * Example: bufferedCount(195, 10) → 195 + ceil(19.5) = 215
 */
export function bufferedCount(count, bufferPct) {
  const c = count || 0;
  const b = bufferPct || 0;
  return c + Math.ceil(c * b / 100);
}

/**
 * Total buffered drones for an event (LS + Pyro, each buffered independently).
 * For tour events with pre-computed _tourMaxLs/_tourMaxPyro, uses those directly.
 */
export function getBufferedTotal(event) {
  if (event._tourMaxLs != null) return event._tourMaxLs + event._tourMaxPyro;
  return bufferedCount(event.ls_drone_count, event.buffer_percentage)
       + bufferedCount(event.pyro_drone_count, event.buffer_percentage);
}
